import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider, Toaster } from '@/shared/ui';
import { queryClient } from '@/lib/queryClient';

/**
 * The query client is provided here, from the app's own import, and the same
 * client goes to `PlatformProvider` so the platform's hooks share the cache and
 * the error policy.
 *
 * In front-apps-monorepo this was also a workaround: the platform package
 * resolved its own copy of `@tanstack/react-query` (against React 18), and a
 * provider from one copy is invisible to `useQuery` from the other ("No
 * QueryClient set"). This repository has one copy.
 */
export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultThemeId="neue" persist>
        <Toaster position="bottom-right">{children}</Toaster>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
